import React, { useState, useEffect } from 'react';

// 統一的商品圖：
// - 載入完成前不顯示醒目的替代圖（星號/大片高彩色塊），只放柔和的中性佔位底。
// - 圖片載入完成後淡入，避免「先看到色塊再跳圖」的閃爍。
// - 出錯或無圖時維持中性佔位（極淡品牌字樣），不顯示破圖。
// - 輪播換圖（src 變更）時：保留 loaded=true 不重觸發淡入（避免閃一下），只重置錯誤旗標。
export default function ProductImage({ src, alt = '', radius = 0, style = {} }) {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [src]);
  const showImg = Boolean(src) && !failed;

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        aspectRatio: '1 / 1',
        overflow: 'hidden',
        background: '#F2F3F9', // 柔和中性佔位，非高彩色塊
        borderRadius: radius,
        ...style,
      }}
    >
      {showImg && (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          onLoad={() => setLoaded(true)}
          onError={() => setFailed(true)}
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            opacity: loaded ? 1 : 0,
            transition: 'opacity .35s ease',
          }}
        />
      )}
      {(!showImg || !loaded) && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            display: 'grid',
            placeItems: 'center',
            pointerEvents: 'none',
          }}
        >
          {!showImg && (
            <span style={{ color: '#D1D5EE', fontSize: 12, letterSpacing: 3, fontWeight: 600 }}>
              ShiningStars
            </span>
          )}
        </div>
      )}
    </div>
  );
}
